import { render, staticRenderFns } from "./CreateCorporateV4.vue?vue&type=template&id=41613160&scoped=true"
import script from "./CreateCorporateV4.vue?vue&type=script&lang=js"
export * from "./CreateCorporateV4.vue?vue&type=script&lang=js"
import style0 from "./CreateCorporateV4.vue?vue&type=style&index=0&id=41613160&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "41613160",
  null
  
)

export default component.exports